import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'
import { isAdmin } from '../../../services/AccountService'
import { getSingleServiceRequest } from '../../../services/CustomerApiService'
import { notifyError } from '../../../services/ToastifyService/ToastifyService'

export const useSingleServiceRequest = (dropFromThisPage?: boolean) => {
  const { serviceRequestId } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (Number.isNaN(+serviceRequestId!) && isAdmin() && !dropFromThisPage) {
      navigate('/service')
      notifyError('Такой страницы не существует')
    }
  }, [serviceRequestId])

  return useQuery({
    queryKey: ['get-single-service-request', serviceRequestId],
    queryFn: () => getSingleServiceRequest(serviceRequestId!),
    select: (data) => ({
      ...data,
      status:
        data.ticketStatus && data.status === 6
          ? `${data.status}.${data.ticketStatus}`
          : data.status,
    }),
    enabled: !Number.isNaN(+serviceRequestId!) && isAdmin(),
    retry: 0,
    staleTime: Infinity,
    gcTime: 0,
  })
}
